import { render, staticRenderFns } from "./NoChangesBlock.vue?vue&type=template&id=e8b63c4a&scoped=true"
import script from "./NoChangesBlock.vue?vue&type=script&lang=js"
export * from "./NoChangesBlock.vue?vue&type=script&lang=js"
import style0 from "./NoChangesBlock.vue?vue&type=style&index=0&id=e8b63c4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b63c4a",
  null
  
)

export default component.exports